import apiHelpers from './apiHelpers';

const rapidApiKeys = [
    '2011e44fa0msh152e4f8043db2f1p1bebc3jsne14cae3ef000',
    'a9a3923195msh5e6b5cefe0f8ce0p11946djsn802fdabd5484',
    '804784a43fmsh0b12336b5133748p11905fjsnfc8062af2a2d',
];
let currentKeyIndex = 0;

async function fetchGooglePlayDetails(bundleId, attempt = 0) {
    const url = 'https://google-play-store-scraper-api.p.rapidapi.com/app-details';
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'X-RapidAPI-Key': rapidApiKeys[currentKeyIndex],
            'X-RapidAPI-Host': 'google-play-store-scraper-api.p.rapidapi.com'
        },
        body: JSON.stringify({
            language: 'en',
            country: 'us',
            appID: bundleId
        })
    });

    if (response.status === 429 || response.status === 403) {
        if (attempt < rapidApiKeys.length - 1) {
            currentKeyIndex = (currentKeyIndex + 1) % rapidApiKeys.length;
            return fetchGooglePlayDetails(bundleId, attempt + 1);
        }
    }

    if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
    }

    const json = await response.json();
    if (!json.success && attempt < rapidApiKeys.length - 1) {
        currentKeyIndex = (currentKeyIndex + 1) % rapidApiKeys.length;
        return fetchGooglePlayDetails(bundleId, attempt + 1);
    }

    return json;
}

export default {
    getApps() {
        return apiHelpers.httpRequest('apps', {}, 'get');
    },
    addApp(data) {
        return apiHelpers.httpRequest('apps', data, 'post');
    },
    updateApp(data, appId) {
        return apiHelpers.httpRequest(`apps/${appId}`, data, 'put');
    },
    deleteApp(data) {
        return apiHelpers.httpRequest(`apps/${data.id}`, {}, 'delete');
    },
    async getAppLogo(data, isIOS) {
        if (isIOS) {
            return apiHelpers.jsonp(`https://itunes.apple.com/lookup?bundleId=${data.bundle_id.toLowerCase()}`);
        } else {
            const json = await fetchGooglePlayDetails(data.bundle_id.toLowerCase());
            return {
                results: [
                    {
                        artworkUrl512: json.data.icon,
                        artworkUrl100: json.data.icon,
                    }
                ]
            };
        }
    },
};
